import D2C_ServiceApp from './App'

class D2C_ServiceNodejs extends D2C_ServiceApp {
  static objectType = 'serviceType'
  static active = true
  static order = 12
  static typeName = 'nodejs'
  static typeTitle = 'Nodejs'
  static color = '#44aa00'
  static methods = {
    ...D2C_ServiceApp.methods,
    scale: true,
  }
  static fields = {
    ...D2C_ServiceApp.fields,
    buildCommands: {
      ...D2C_ServiceApp.fields.buildCommands,
      examples: ['npm install -g'],
    },
    deployCommands: {
      ...D2C_ServiceApp.fields.deployCommands,
      default: 'npm install',
    },
    hosts: {
      ...D2C_ServiceApp.fields.hosts,
      selector: {
        default: ['node', 'node'],
      },
    },
    image: {
      ...D2C_ServiceApp.fields.image,
      default: 'node',
    },
    ports: {
      ...D2C_ServiceApp.fields.ports,
      default: [
        {protocol: 'TCP', value: 3000},
      ],
    },
    preinstall: {
      ...D2C_ServiceApp.fields.preinstall,
      enum: ['bower', 'grunt', 'gulp', 'webpack'],
    },
    source: {
      ...D2C_ServiceApp.fields.source,
      example: 'https://github.com/d2cio/nodejs-hello-world',
    },
    startCommand: {
      default: 'npm start',
      label: 'Command to start',
      path: 'startCommand',
      required: false,
      syntaxis: 'shell',
      validate() {
        return null
      },
      creating: {},
      importing: {},
      updating: {},
    },
    version: {
      ...D2C_ServiceApp.fields.version,
      default: '16',
      enum: ['12', '14', '16', 'latest'],
    },
    volumes: {
      ...D2C_ServiceApp.fields.volumes,
      demo: [
        {src: '/ebs/containers/$serviceName/sources', dst: '/var/www/$serviceName', sync: false},
      ],
    },
  }
}

export default D2C_ServiceNodejs
